module.exports = __webpack_public_path__ + "img/9788957982341.5814c38a.jpg";